export default {
  setup() {
    return {}
  },
}
